// extracted by mini-css-extract-plugin
module.exports = {"row":"index-module__row___2hsCy","col":"index-module__col___O7O5n","edit":"index-module__edit___2809U"};